import type { Element } from '@/types';

// Project interface
export interface Project {
  id: string;
  name: string;
  elements: Element[];
  viewport: {
    zoom: number;
    offsetX: number;
    offsetY: number;
  };
  createdAt: number;
  updatedAt: number;
}

// Storage keys
export const STORAGE_KEYS = {
  PROJECTS: 'canvasDraw_projects',
  CURRENT_PROJECT_ID: 'canvasDraw_currentProjectId',
  PROJECT_COUNTER: 'canvasDraw_projectCounter',
} as const;
